module.exports = __webpack_public_path__ + "img/preloader493x493.12e8cc85.gif";